"use client";
import * as React from "react";
const SvgQueryStatsOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.73 11.76q.5-.75.51-1.7a3.24 3.24 0 0 0-3.27-3.22c-1.81 0-3.28 1.44-3.28 3.22s1.47 3.21 3.27 3.21q.97-.01 1.74-.5L14.97 15 16 13.99zm-2.76.08c-1 0-1.82-.8-1.82-1.78s.81-1.79 1.82-1.79 1.82.8 1.82 1.79-.82 1.78-1.82 1.78m-.26-6.07a4 4 0 0 0-1.53.32l-.4-.59L6 9.91 3.83 7.4l-2.64 4.15L0 10.71 3.64 5l2.18 2.5 2.9-4.64zm1.88.36a4 4 0 0 0-1.5-.35L14.83 0 16 .84z" }));
export {
  SvgQueryStatsOutlined as default
};
